<template>
   <g>
      <path
         d="M7.48929 9.4386H4.02206C2.35302 9.436 1 8.1336 1 6.52686C1 4.92011 2.35302 3.61835 4.02206 3.61835C4.27709 2.47494 5.18624 1.54178 6.40688 1.16994C7.62687 0.798757 8.97404 1.0447 9.93965 1.81887C10.9053 2.5911 11.3426 3.7702 11.0883 4.91362H11.7307C12.3511 4.91362 12.913 5.1667 13.3199 5.57552M12.0324 11.3828C11.6882 11.3828 11.3581 11.2461 11.1147 11.0027C10.8713 10.7593 10.7346 10.4291 10.7346 10.0849C10.7346 9.74072 10.8713 9.41061 11.1147 9.16721C11.3581 8.92381 11.6882 8.78708 12.0324 8.78708M12.0324 11.3828C12.3767 11.3828 12.7068 11.2461 12.9502 11.0027C13.1936 10.7593 13.3303 10.4291 13.3303 10.0849C13.3303 9.74072 13.1936 9.41061 12.9502 9.16721C12.7068 8.92381 12.3767 8.78708 12.0324 8.78708M12.0324 11.3828V12.3562M12.0324 8.78708V7.81368M13.9994 8.94931L13.1564 9.436M10.9091 10.7339L10.0655 11.2206M10.0655 8.94931L10.9091 9.436M13.1564 10.7339L14 11.2206"
         stroke="white"
         stroke-linecap="round"
         stroke-linejoin="round"
      />
   </g>
</template>

<script>
export default {
   data() {
      return {
         name: 'icon-cloud-computing',
         viewBox: '0 0 15 13',
         width: 15,
         height: 13,
         fill: 'none',
      };
   },
};
</script>
